import React from 'react';
import { labelInfo } from '../mock/data';
import { Instagram, Facebook, Mail } from 'lucide-react';
import { FaTiktok, FaSoundcloud } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-black border-t border-green-500/20">
      {/* Top accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-green-500 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Logo & Description */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/g7fudt7e_137643.jpg" 
              alt="Numerounosounds" 
              className="h-20 w-auto"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              {labelInfo.tagline}
            </p>
            <p className="text-gray-500 text-xs">
              Est. {labelInfo.established}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-green-400 transition-colors duration-300 text-sm"
                >
                  About
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('artists').scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-green-400 transition-colors duration-300 text-sm"
                >
                  Artists
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('releases').scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-green-400 transition-colors duration-300 text-sm"
                >
                  Releases
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('demo').scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-green-400 transition-colors duration-300 text-sm"
                >
                  Submit Demo
                </button>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Connect</h3>
            
            {/* Email */}
            <div className="mb-6 space-y-2">
              <div>
                <p className="text-gray-500 text-xs mb-1">Numero Uno Sounds:</p>
                <a 
                  href={`mailto:${labelInfo.contact.email}`}
                  className="flex items-center gap-2 text-gray-400 hover:text-green-400 transition-colors duration-300 text-sm"
                >
                  <Mail size={16} />
                  {labelInfo.contact.email}
                </a>
              </div>
              <div>
                <p className="text-gray-500 text-xs mb-1">Lost in Bass:</p>
                <a 
                  href={`mailto:${labelInfo.contact.demos}`}
                  className="flex items-center gap-2 text-gray-400 hover:text-green-400 transition-colors duration-300 text-sm"
                >
                  <Mail size={16} />
                  {labelInfo.contact.demos}
                </a>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex gap-3">
              <a 
                href={labelInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-zinc-800/50 rounded-lg hover:bg-green-500/20 border border-green-500/20 hover:border-green-500 transition-all duration-300 text-gray-400 hover:text-green-400"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href={labelInfo.social.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-zinc-800/50 rounded-lg hover:bg-green-500/20 border border-green-500/20 hover:border-green-500 transition-all duration-300 text-gray-400 hover:text-green-400"
                aria-label="TikTok"
              >
                <FaTiktok size={20} />
              </a>
              <a 
                href={labelInfo.social.soundcloud}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-zinc-800/50 rounded-lg hover:bg-green-500/20 border border-green-500/20 hover:border-green-500 transition-all duration-300 text-gray-400 hover:text-green-400"
                aria-label="SoundCloud"
              >
                <FaSoundcloud size={20} />
              </a>
              <a 
                href={labelInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-zinc-800/50 rounded-lg hover:bg-green-500/20 border border-green-500/20 hover:border-green-500 transition-all duration-300 text-gray-400 hover:text-green-400"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-green-500/20">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} {labelInfo.name}. All rights reserved.
            </p>
            <p className="text-gray-600 text-xs">
              Underground Drum & Bass | Worldwide Distribution
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
